import { IconButton } from '@mui/material';
import { FaArrowLeftLightSvgIcon } from '../../assets/icons/svgs';
import { fontSize } from '../../theme/typography';
import { colors } from '../../theme/colors';
import { CSSProperties } from 'react';

interface BackButtonProps {
  onClick: () => void;
  style?: CSSProperties;
}

const BackButton = ({ onClick, style }: BackButtonProps) => {
  return (
    <IconButton onClick={onClick} style={style}>
      <FaArrowLeftLightSvgIcon
        size={fontSize['2xl']}
        fill={colors.textPrimary}
      />
    </IconButton>
  );
};

export default BackButton;
